import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, BRAND } from "@/lib/avocado";
import { BrandLogo } from "@/components/brand/BrandLogo";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, name: "", error: "" });

  useEffect(() => {
    if (!token) { setState({ loading: false, ok: false, name: "", error: "Missing unsubscribe token" }); return; }
    api.post(`/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState({ loading: false, ok: true, name: data.name || "", error: "" }))
      .catch((err) => setState({ loading: false, ok: false, name: "", error: err.response?.data?.detail || "Could not unsubscribe" }));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#FFFCF7" }}>
      <div className="w-full max-w-md text-center">
        <div className="mb-8 flex justify-center"><BrandLogo /></div>
        {state.loading ? (
          <Loader2 className="animate-spin mx-auto" size={28} style={{ color: BRAND.pink }} />
        ) : state.ok ? (
          <>
            <CheckCircle2 size={44} className="mx-auto mb-4" style={{ color: BRAND.pink }} />
            <h1 className="font-display text-3xl md:text-4xl mb-2" style={{ fontWeight: 700 }}>All done{state.name ? `, ${state.name.split(" ")[0]}` : ""}.</h1>
            <p className="text-sm mb-6" style={{ color: "#7A6D5F" }}>You've unsubscribed from the weekly digest. You'll still get transactional emails (referral status updates, password resets).</p>
          </>
        ) : (
          <>
            <XCircle size={44} className="mx-auto mb-4" style={{ color: "#B91C1C" }} />
            <h1 className="font-display text-3xl md:text-4xl mb-2" style={{ fontWeight: 700 }}>Hmm, that didn't work.</h1>
            <p className="text-sm mb-6" style={{ color: "#7A6D5F" }}>{state.error}</p>
          </>
        )}
        <Link to="/login" className="font-bold underline underline-offset-4" style={{ color: BRAND.pink }}>← Back to sign in</Link>
      </div>
    </div>
  );
}
